<template>
 <div class="pos class-1" id="pos"> 
              
              <PosAppHeader /> 
  
    <body class="pos class-1" id="takeaway">
      <!-- main box -->
      <div class="main_box">
        <div class="left_panel">
          <div class="cards-container d-flex flex-row flex-wrap">
            <!-- Dynamic cards based on API data -->
            <div v-for="order in orders" :key="order.id" class="takeaway-cards p-2"  @click="navigateToPos(order.id)">
              <div class="d-flex flex-column align-items-center">
                <div class="symbol">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <image style="overflow:visible;" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
                                    bWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp
                                    bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6
                                    eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1
                                    MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo
                                    dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw
                                    dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAv
                                    IiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RS
                                    ZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpD
                                    cmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJ
                                    RD0ieG1wLmlpZDozRkYxMkQ4MTA4QkYxMUVEODdGOTk2QThFMUE2MDczQiIgeG1wTU06RG9jdW1l
                                    bnRJRD0ieG1wLmRpZDozRkYxMkQ4MjA4QkYxMUVEODdGOTk2QThFMUE2MDczQiI+IDx4bXBNTTpE
                                    ZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjNGRjEyRDdGMDhCRjExRUQ4N0Y5
                                    OTZBOEUxQTYwNzNCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjNGRjEyRDgwMDhCRjExRUQ4
                                    N0Y5OTZBOEUxQTYwNzNCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBt
                                    ZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+UIuSOgAADrJJREFUeNrs3V1u6zYUhdHQ0AQy/0HeIfA+
                                    9AftRZA4sUgecq8FFGgfmkSSzfOJtpPWe38DALI8nAIAEAAAgAAAAAQAACAAAAABAAAIAACgquvV
                                    L/Dr1y9nEYA7+MU0n2v//Y/39/e1AQAABv/U89Tu+GJeAgDA8A88ZwIAAAIJAADc/QeeOwEAAHYA
                                    AAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAM5c8Bw978LnWSNc9fAQAGPoAAAEMfQACA
                                    oQ8gAMDgB9L5FAAY/oAdAMDgBwQAYPADAgAw+AEBABj8gAAADH5gFz4FAIY/YAcAMPgBAQAY/IAA
                                    AAx+QAAABj8gAMDgL6q5XHgeIQDgzEXLkAcEAIQMfkMfEABg8AMIADD4AQQAGPwAAgAMfiCcvwUA
                                    hj9gBwAMfoMfEABg8Bv8gAAAg9/gBwQAGPwGPyAAwOA3+IFd+BQAhr/hD9gBAIPf4AcEABj8Bj8g
                                    AMDgN/gBAQAGv8EPCAAw+AF24VMAGP6GP2AHAAx+gx8QAGDwG/yAAACDH0AAgMEPIADA4AfYhU8B
                                    YPgb/oAdADD4AQQAGPwAAgAMfgABAAY/gAAAgx9gFz4FgOEPYAfAwEGQsDWhByEBYFEHPloThAB8
                                    4bHxk9zwB9wcQFAAeGIDQFgAGP6A9QJucHkiA4AdAMMfAAQAACAA3P0DgAAw/AFAABj+ACAAAAAB
                                    4O4fmMuvAwY7AABA5QBw9w+4+wc7AACGP4xQ6VcBj7r7txjA2c9xz/d9rxcCwEIAhonnvOGPALAQ
                                    gGHiOW/wM9TjwAedhQAMfwx/NgkACwEYKJ7zhj8CADBQDH84PQDuWigsBmD44+4fOwCA4Y/hjwAA
                                    DH/guACwKIDhD9gBAAx/QAAAhj8gAADDHwQAgOHvGiIAAAx/EAAAhj8c6HIKAMOfRdfLyxB2AADD
                                    3/AHAQAY/oAAAAx/QAAAhj/1ry0CADAgDH8QAIDhb/ifwDUUADELFhj+BodrzDH8HgDA8Mdj1g4A
                                    YCE1/F1nBMAczQMbDH+2us6upwAADAXDAgRAxmIGni+Gv2uNACi4SHigg+HPuGvtugoAtQueH4aE
                                    a40AqPnA9+AHwx/Xlg9cxR5YIxYnEQAGhNCDoB0AwPA3/F1fNgkADzAw/HHnzwR+FTBg+Bv8rrEd
                                    AIsJ4Plq+Hv8JJw7OwCAxdvgd53tAFhYAM/R4kN/5kecm8fSuc+/q/gBekMLGP7u7HMeU9b8ic+9
                                    a4OD9YAAw99wzrjW4nIi7wEALM4Gv2sd6OGBCHgeGv6utQCo/ID0oAQDwfB3rQkLAA9O8JybPfgN
                                    fwSABykY/u76XWsEQJUHqwcsGAiGv2vND10HPXB9XBAMBMPftSYkAEbGgCcGiYOqOZ8GPxkensyA
                                    4e86YwcAyBxYhr/BjwAADAaD3/VFAGQ+sT1hSBlchr/BjwAA3Bka/q4rAgAwJAx/1xMBEPQE90Ti
                                    9AHWnDcDH+wAAIa/AU+gh1MAUVIGi98HAnYALI4Q9Pg2+CFsB8CTHkON7lggLwAAwx8QAMAfTt7+
                                    N/whNAB8/A9y7/r74ccHAgDAcAQBABj+wAt8DPAvtv/B4Ac7ABYEIPy53kKPGwEAYPiDAAAw/OEo
                                    O78HwMf/wOAfNfh7sXNhncIOAGD4u+sHAQDUHKqGPwiA0ouEJz/UeU5XGf53ri/txvMDAgDCnB6q
                                    Kwa/+EcAOAUQdZdt+APxAWAhAMPf+oIAsGiAoTvxZ5j5c3xny78P+v7WPgQAsPyOcuUgseUPAgAI
                                    2wkw/EEALF9ALAwwbyBX+ojfqvXFywAIAKBUuI4eKD7iBwIACNsJsOUPAqDUYmKRwC7Ax8+vXvBr
                                    zTovM9YXaw+lXE4B8MEgXPkauqD/+jyLCQQAhO4CzH7tvhUZ+O6oQQAAC3YGKkUQ8IJd3gPg9X/w
                                    WB517DPXFx8HRAAAIuAHxyviQQAAQQPR4IfAALD9DyLnpPXFywAIAEDcfnFcwh0EABAUAQY/CACL
                                    CYQ9zpufFwSA17jg+8Oobf7zJ6wv3geAAADclb55vR8EABAXAQY/CID/8fE/OPvOeuXPVmF98TIA
                                    AgCICwFhDov5Y0CQFwIr7xoNfhAAn7L9D+eEQLXnYaX1pb3ZwkcAAIvvyPugr8ucqHHOEQDArUO7
                                    G/QgAE5YzADPJeeEeBU/BeD1MCBpffFxQAQAACAAAICQAPDxPyBxffEyAHYAAAABAAAIgKfY/ges
                                    L7BRAHjtCkheX7wPADsAAIAAAAAODQAf/wOsL14GwA4AACAAAIDjAsD2P2B9sZZhBwCAQvGDAAAA
                                    BEAttswA6wtsFAC2qADry7josMZy/A4AACAAAICqAeDjf4D1Zfz39jIAdgAAAAEAAAJgMtv/gPUF
                                    7AAAMDBCvA8AAQAACAAAEACTeH0OsL7M/1m8DIAdAAAQAACAABjM9j9gfbHmYQcAgA0jCQEAAAiA
                                    OWyFAdYX2CgAbD0B1pf1cWItZtsdAABAAAAAVQPAx/8A60udn9HLANgBAAABAAAIgJvY/gesL2AH
                                    AIACseJ9AAIAABAAZxcvgPUFJgSALSbA+lI3WqzRAgAAEAAAgAD4IR/PAawv41gbsQMAwPKYQgAA
                                    AALgNba4AOsLbBQAtpSAUawv90eMcyoAAAABAAAIgCf5eA4wivVl3LF4GUAAAAACAAAQAF+wPQeM
                                    Yn0BOwAADIga7wMQAACAANizZAGsLzAhAGwdAaNYX+bFjXMtAAAAAQAACIA/+HgOMIr1xTEywOUU
                                    TF+smu/vseD8sMFj12NRAHDzYt8HLfTp3/+UO9WTzw9QSKX3AOy84PVJ/4/vX/f69wKPKc5cX6Bs
                                    AFioSNQHDX6sL1Vix7kXAAx8knTf31CyAAMreA8AGMiAHYBlvD5H9cFv+O+rOWaoGwDgrh9AAIDh
                                    DyAAwPAHuJU3AYLBD9gBAMMfQADM4d2qGP5YX8AOABj+IH4QAACAAAB3/wCv8ykADH+Y95iyLY8A
                                    AMOfwMdTFwJU4SUALNbjWOQ9ngQodgAgiMEP2AGAsLt/w9/jyS4AdgAgaPgb/IAdAAhj+AMCAMLu
                                    /g1/QACA4Q8gAOBkhj8gACDs7t/wBwQAuPMHEABw8t2/4Q8IAABAAIC7fwABAEcx/IHj+FXA592p
                                    7vb9HROAHQBw9w8gAMDdP4AAAHf/AAIARt79G/6AAAAABACczt0/IABgE978ByAAwN0/gADA3T8A
                                    AgAABADwD9v/gADA0Njk3Nn+BxAAIOQABIDh4ZwBIAA4ju1/gB+6nIJb72hP/l30Jx+b3QjADgAA
                                    IABYdydZaXu74t1/L3jNAAQAACAA7ALsuwtw8mv/AAIAABAA2AWofPfv9X8AAQAACAC7AKff/QMg
                                    AECUAAgAuwAJd/9+/S+AAAAABIBdgNPv/gEQACBMAASAXYCEu3+v/wMIAADgpy6nYOouwF13sH2D
                                    YwXADgCIEwABYPg4RgAEADzBGwABBIA7ZMcGgAAAgQIgAAwixwSAAAAABIA75g2PxRsAAQQAACAA
                                    4DneowAgAABAAAAAAgAAEACwlk8AAAgAAOAOl1OwvVff3e4OG8AOAIgkAAEAAAgA2JSXOQAEAMER
                                    IAQABIC70tBjEQIAAoC33DfICQFAAGB4BxMCgAAAIQAgAEAIAAgAiAsBAAEAAAgAmGXlGx3tAgAC
                                    AAAQAJCyCwAgAGBxBAgBgJtcTgGb7gbMen3e+wAAOwBgRwBAAIAQABAAfEN3TEIAQACAEAAQADw9
                                    6Cp+LSEAIAAAAAEAc3XHACAAAAABAAACAAAQAACAAAAABAAAIAAAAAEAAFR3OQXwqVd/nbBf5APY
                                    AeD4gdD9LI4FEAAAgADgRm2Tr+k8O6+AAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQANAdE4AAAAAE
                                    ADylFf1aAAIAABAAO+iOEQABAAAIAJ7SNv3aAAgAAEAAAAACAAAQAPAd3bEBCAAAQADAU9omXxNA
                                    AAAAAgAAEAAAgAAAAAEAAAgARumOFQABAAAIAJ7SDvkeoyTsPNhdAQQAACAA4A5t068NIAAAAAEA
                                    AAgAAEAAAIAAAAAEAAAgAAAAAQCV+FsLAAIAABAA7tgc83P8rQVAAAAAAoCMu1N3qQACAAAQAACA
                                    AAAABAAAIAAAAAEAY/k9CwACAAAQAPAcv2cBEAAAgAAAAAQAACAAAAABAJvqh34vAAFgQBlQAAgA
                                    znHXx+pmhE8vdsyAAMAugLv/wcdvZwUQALw0RPoGX7dtfo4Nf+Bol1MwRRswAPoNw9ZQev7cNOcW
                                    EAAk3LGKrLrn2Ov/wMu8BGDRdqwAAgAAEACwl+YYAQSAxdsxAiAADMiQY3N+AQQAIssxAQgAi3nS
                                    MTXnFkAAWNQdCwACwOAMOQbnF0AAWOBDf3bnF0AAWOhDf+bm5wUQABb93OFkxwJAABgAocOpasC4
                                    6wem8tcAaw/aXuzncY6dW0AAMHk49IXf2zl2bgEBgDtF5xhgd94DAAACAAAQAACAAADgX73I1wAB
                                    ALDR8BcBCACA0OEvAhAAAKHDXwQgAABCh78IQAAAhA5/EYAAAAgd/iIAAQAQOvxFAAIAIHwAiwAE
                                    AEDo4BUBCACA0IErAhAAAKGDVgQgAABCB6wIQAAAhA5WEYAAAAgdqCIAAQAQOkhFAAIAIHSAigAE
                                    AECxwdn+/kcEIAAAgob/R/8uAhAAAAHDXwQgAABCh78IQAAAhA5/EYAAAAgd/iIAAQAQOvxFAAIA
                                    4ABt0f8LAgBgw+EvAhAAAKHDXwQgAABCh78IQAAAhA5/EYAAAAgd/iIAAQAQOvxFAAIAIHT4iwAE
                                    AEDo8BcBCACA8AEsAhAAAKGDVwQgAABCB64I4HZXgZ/BH6wAKrEmYQcAABAAAIAAAAAEAAAgAAAA
                                    AQAACAAAQAAAAAIAABAAAIAAAAAqBIA/UgFwHmu7AAAABIBSBHD3z/auAQ8Yf0oTwOCn+sXu3bwG
                                    gDTeAwAAAgAAEAAAgAAAAAQAACAAAAABAACU9VuAAQBJZy7fCyQoAAAAAABJRU5ErkJggg==" transform="matrix(1 0 0 1 0.7209 1.5116)">
                                    </image>  
                </svg>
                </div>
                <div class="order-no">
                  <span class="light">Order #: </span>
                  <span class="order-id heavy">{{ order.id }}</span>
                </div>
                <div v-if="order.customerName" class="order-no">
                  <span class="light">Customer </span>
                  <span class="order-id heavy">{{ order.customerName }}</span>
                </div>
                <div class="amount mt-2">
                  <span class="light">Amount: </span>
                  <span class="amount-value heavy">{{ order.totalPay }} AED</span>
                </div>
                <!-- <div class="opencard mt-2">
                  <span>OPEN</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        orders: []
      }
    },
    methods: {
      navigateToPos(orderId) {
         if (!this.$hasPermission('edit orders')){
        this.$toast.error('Not Permitted');
        return;
    }
      this.$router.push({ name: "PosComponent" , params: { orderId: orderId}});
    },
    },
    async created() {
      try {
        this.$root.isLoading = true; 
          this.loading = true;
        const response = await fetch(`${this.$BASE_API_URL}/api/orders/types?types=3`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}` 
      },
    });
        const data = await response.json();
        if (data.status && data.data) {
          this.orders = data.data;
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
      finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
    }
  }
  </script>
